import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from "../environments/environment";

import {finalize, Observable} from 'rxjs';
import {AuthenticationState} from "../store/auth/auth.state";

@Injectable()
export class ActionInterceptor implements HttpInterceptor {
  constructor(private authState: AuthenticationState) {
  }


  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if(request.url.startsWith(environment.url) && request.method!="GET") {
      this.authState.setBusy(true);
      return next.handle(request).pipe(finalize(() => {
        console.log("Request intercepted");
        this.authState.setBusy(false);
      }
      ));
    }
    return next.handle(request);
  }
}
